<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <vc-viewer style="display:none;" class="viewer" :animation="animation" :timeline="timeline" :camera.sync="camera" @ready="ready">
    
  </vc-viewer>
</template>

<script>

  //import { Cesium, Viewer} from 'cesium/Build/Cesium/Cesium'
  //import { Cesium, Cesium3DTileset, createWorldTerrain, Viewer } from 'cesium/Build/Cesium/Cesium';
  
  //import Cesium from 'cesium'
  // import { Cesium, Viewer} from 'cesium/Build/Cesium/Cesium'

  // import "cesium/Build/Cesium/Widgets/widgets.css";

  import Vue from 'vue'
  import { Viewer, ImageryLayer } from 'vue-cesium'
  Vue.use(Viewer, {
    // cesiumPath is path of Cesium.js', for example:
    // local Cesium Build package:
    cesiumPath: '/Cesium/Cesium.js'
    // Personal online Cesium Build package：
    // cesiumPath: 'https://zouyaoji.top/vue-cesium/statics/Cesium/Cesium.js'
    // Personal online SuperMap Cesium Build package：
    // cesiumPath: 'https://zouyaoji.top/vue-cesium/statics/SuperMapCesium/Cesium.js'
    // Official Online Cesium Build package：
    // cesiumPath: 'https://unpkg.com/cesium/Build/Cesium/Cesium.js',
    // Cesium.Ion.defaultAccessToken
    // accessToken: ''
  }),
  Vue.use(ImageryLayer)

  
  export default {
    name: 'Globe',
    data: () => ({
      cesiumInstance: null,
      animation: true,
      timeline: true,
      camera: {
        position: {
          lng: 104.06,
          lat: 30.67,
          height: 100000
        },
        heading: 360,
        pitch: -90,
        roll: 0
      }
    }),
    mounted () { // this vue component       
    },
    methods: {
      ready(cesiumInstance) {
        this.cesiumInstance = cesiumInstance
        this.testDraw()

      },
      testDraw() {
        var { Cesium, viewer } = this.cesiumInstance


        viewer.entities.add({
          id: 'Welcome to Chengdu',
          position: Cesium.Cartesian3.fromDegrees(104.06, 30.67, 100),
          billboard: new Cesium.BillboardGraphics({
            image: 'https://zouyaoji.top/vue-cesium/favicon.png',
            scale: 0.1
          }),
          label: new Cesium.LabelGraphics({
            text: 'RED GLOBE!!!!',
            fillColor: Cesium.Color.RED,
            font: '24px sans-serif',
            horizontalOrigin: 1,
            outlineColor: new Cesium.Color(1, 0, 0, 1),
            outlineWidth: 2,
            pixelOffset: new Cesium.Cartesian2(17, -5),
            style: Cesium.LabelStyle.FILL
          })
        })
      }
    }
  }
</script>

<style scoped>
  .viewer  {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
